import { FieldErrors, useFormContext } from 'react-hook-form'
import { BefehlFormField } from '../Generic'
import AuftragCheckbox from '../Generic/AuftragCheckbox'
import { useTranslation } from 'react-i18next'
import { useEffect, useMemo } from 'react'
import { Befehl31FormData } from './schema'
import Feld31_16Form from './Feld31_16Form'

export interface Auftrag31_14_15FormProps {
  readOnly: boolean
  'data-testid': string
  activateEmptyFieldWarnings: boolean
  errors?: FieldErrors
}

export default function Auftrag31_14_15Form({
  readOnly,
  'data-testid': testId,
  activateEmptyFieldWarnings,
  errors
}: Readonly<Auftrag31_14_15FormProps>) {
  const { t } = useTranslation('ui-befehle')

  const { control, formState, watch, setValue } =
    useFormContext<Befehl31FormData>()

  const fieldErrors = useMemo(() => {
    return errors ?? formState.errors
  }, [errors, formState.errors])

  const auftrag_31_14 = watch('auftrag31_14')
  const auftrag_31_15 = watch('auftrag31_15')

  useEffect(() => {
    if (auftrag_31_14) {
      setValue('auftrag31_15', false)
      setValue('feld31_16', '')
    }
  }, [auftrag_31_14, setValue])

  useEffect(() => {
    if (auftrag_31_15) {
      setValue('auftrag31_14', false)
    }
  }, [auftrag_31_15, setValue])

  return (
    <div className="flex flex-wrap gap-2 items-baseline">
      {(!readOnly || auftrag_31_14) && (
        <BefehlFormField
          name="auftrag31_14"
          control={control}
          label=""
          readOnly={readOnly}
          activateEmptyWarning={activateEmptyFieldWarnings}
          data-testid={`${testId}-auftrag-31-14`}
          render={({ field }) => (
            <div className="flex items-baseline gap-0.5">
              <div className="flex justify-center items-start pt-0.25">
                <AuftragCheckbox
                  checked={field.value}
                  label={`31.14`}
                  onChange={(e) => field.onChange(e.target.checked)}
                  readOnly={readOnly}
                  data-testid={`${testId}-auftrag-31-14-inner`}
                  errors={fieldErrors}
                />
              </div>
              <span data-testid={`${testId}-auftrag-31-14-text`}>
                {t('befehle.31.text.signal_ra_10')}
              </span>
            </div>
          )}
        />
      )}

      {!readOnly && (
        <span data-testid={`${testId}-text-oder`}>
          {t('befehle.31.text.oder')}
        </span>
      )}

      {(!readOnly || auftrag_31_15) && (
        <div className="flex flex-wrap gap-2">
          <BefehlFormField
            name="auftrag31_15"
            control={control}
            label=""
            readOnly={readOnly}
            activateEmptyWarning={activateEmptyFieldWarnings}
            data-testid={`${testId}-auftrag-31-15`}
            render={({ field }) => (
              <div className="flex items-baseline gap-0.5">
                <div className="flex justify-center items-start pt-0.25">
                  <AuftragCheckbox
                    checked={field.value}
                    label={`31.15`}
                    onChange={(e) => field.onChange(e.target.checked)}
                    readOnly={readOnly}
                    data-testid={`${testId}-auftrag-31-15`}
                    errors={fieldErrors}
                  />
                </div>
                <span data-testid={`${testId}-auftrag-31-15-text`}>
                  {t('befehle.31.text.einfahrweiche')}
                </span>
              </div>
            )}
          />

          <Feld31_16Form
            readOnly={readOnly}
            data-testid={`${testId}-feld-31-16`}
            errors={fieldErrors}
            activateEmptyFieldWarnings={activateEmptyFieldWarnings}
          />
        </div>
      )}
    </div>
  )
}
